export const LOCATIONS = {
  HOME_PAGE: '/',
  LOGIN: '/login',
  PLAY_LIST: '/play-list',
  FORM: '/form',
  TAB: '/tabs',
  SLIDE: '/slider',
  PRODUCTS: '/products',
  PRODUCTS_ADD: '/products/add',
  TEMPLATE: '/template',
  COUNTER: '/counter',
  TODO: '/todo',
  MY_PROFILE: 'my-profile',
  ANT_DESIGN: '/antd',
  ANT_DESIGN_HOME_PAGE: '/antd/home',
  PRODUCTS_PAGE: '/products',
  PRODUCTS_DETAIL_PAGE: '/products/:id',
};